/* global ha */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {SearchForm} from '@homeaway/react-search-form';

import {setSearchData, redirect} from '../../../actions/search';
import {getSearchValues} from '../../../utils/search';

import {
    getOptions,
    getSettings,
    getTranslations,
    getValues,
} from './utils/search-form';

export function mapStateToProps({abacus, config, destination, i18n, modules, search}) {
    const {
        site: {
            basePath
        },
    } = config;

    const {
        searchBoxLite: {
            labels,
            resetForm
        }
    } = modules;

    return {
        abacus,
        basePath,
        resetForm,
        ...getOptions(config, i18n),
        ...getSettings(config),
        ...getTranslations(labels),
        ...getValues(destination, search),
    };
}

export class SearchFormComponent extends Component {
    static propTypes = {
        resetForm: PropTypes.bool,
        systemOptions: PropTypes.shape({
            site: PropTypes.string,
            baseUrl: PropTypes.string,
            appPrefix: PropTypes.string,
            locale: PropTypes.string
        }),
        mediaSettings: PropTypes.shape({
            isMobile: PropTypes.bool
        }),
        edapOptions: PropTypes.shape({
            searchQuerySubmittedEventActionLocation: PropTypes.string
        }),
        formOptions: PropTypes.shape({
            layout: PropTypes.oneOf(['standard', 'feature'])
        }),
        searchValues: PropTypes.shape({
            filters: PropTypes.arrayOf(PropTypes.number)
        }),
        destinationTranslations: PropTypes.objectOf(PropTypes.string),
        destinationValues: PropTypes.shape({
            destination: PropTypes.string,
            destinationUuid: PropTypes.string
        }),
        datesOptions: PropTypes.objectOf(PropTypes.object),
        datesTranslations: PropTypes.objectOf(PropTypes.string),
        datesValues: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        guestsTranslations: PropTypes.objectOf(PropTypes.string),
        guestsValues: PropTypes.shape({
            adultsCount: PropTypes.number,
            childrenCount: PropTypes.number,
            petIncluded: PropTypes.bool
        }),
        submitTranslations: PropTypes.objectOf(PropTypes.string)
    };

    static defaultProps = {
        resetForm: false
    };

    componentDidMount() {
        ha.userTiming.mark('primary.action.rendered');
        ha.userTiming.mark('datepicker.active');

        this.checkSearchData();
    }

    checkSearchData = () => {
        const cookies = document.cookie;
        const {abacus, datesValues, guestsValues, dispatch} = this.props;

        const searchCookies = getSearchValues(cookies, abacus);

        if (!searchCookies || !(datesValues || guestsValues)) {
            return;
        }

        const {
            startDate: arrivalDate,
            endDate: departureDate
        } = datesValues;

        const {
            adults,
            children,
            petIncluded
        } = guestsValues;

        const searchValues = {
            arrivalDate,
            departureDate,
            adults,
            children,
            petIncluded
        };

        const differentSearchData = [
            'arrivalDate',
            'departureDate',
            'adults',
            'children',
            'petIncluded'
        ].some((property) =>
            searchValues[property] !== searchCookies[property]);

        if (differentSearchData) {
            dispatch(setSearchData(searchCookies));
        }
    }

    onSubmit = ({searchPath}) => {
        const redirectPath = `${this.props.basePath || ''}${searchPath}`;
        this.props.dispatch(redirect(redirectPath));
    };

    render = () => {
        const {
            onSubmit
        } = this;

        const {
            resetForm,
            systemOptions,
            mediaSettings,
            edapOptions,
            formOptions,
            searchValues,
            destinationTranslations,
            datesOptions,
            datesTranslations,
            datesValues,
            guestsTranslations,
            guestsValues,
            submitTranslations
        } = this.props;

        let {
            destinationValues
        } = this.props;

        if (resetForm) {
            destinationValues = {};
        }

        const formEvents = {
            onSubmit
        };

        return (
            <SearchForm
                systemOptions={systemOptions}
                mediaSettings={mediaSettings}
                edapOptions={edapOptions}
                searchValues={searchValues}
                formEvents={formEvents}
                formOptions={formOptions}
                destinationTranslations={destinationTranslations}
                destinationValues={destinationValues}
                datesOptions={datesOptions}
                datesTranslations={datesTranslations}
                datesValues={datesValues}
                guestsTranslations={guestsTranslations}
                guestsValues={guestsValues}
                submitTranslations={submitTranslations}
            />
        );
    };
}

export const SearchFormContainer = connect(mapStateToProps)(SearchFormComponent);

SearchFormContainer.displayName = 'SearchFormContainer';

export default SearchFormContainer;
